import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { AsyncPipe, TitleCasePipe } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SearchLinkModule } from 'src/app/shared/search-link/search-link.module';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { ReplaceStrPipe } from 'src/app/shared/pipes/replace-str.pipe';
import { ParseCoordinatesPipe } from 'src/app/shared/pipes/parse-coordinates.pipe';

import { ScrollToIdService } from 'src/app/core/services/scroll-to-id.service';
import { CountryInfoTextService } from '../../../services/country-info-text.service';
import { MetaTagsConfigService } from 'src/app/core/services/meta-tags-config.service';

import { RegionDetails } from 'src/app/core/types/models/region-details.model';
import { RegionResponse } from 'src/app/core/types/models/region-response.model';
import { UserAccountModule } from '../../../../user-account/user-account.module';

import { PageInfoComponent } from '../../../pages/page-info';
import { GalleryComponent } from 'src/app/shared/components/gallery/gallery.component';
import { TripsListComponent } from '../../../components/trips-list/trips-list.component';
import { SimpleMapComponent } from 'src/app/shared/maps/simple-map/simple-map.component';
import { TextEllipsisComponent } from 'src/app/shared/components/text-ellipsis/text-ellipsis.component';
import { SimpleBreadcrumbComponent } from '../../../components/simple-breadcrumb/simple-breadcrumb.component';
import { PopularItinerariesComponent } from 'src/app/shared/components/popular-itineraries/popular-itineraries.component';
import { SearchInputFieldComponent } from 'src/app/shared/components/forms/search-input-field/search-input-field.component';

@Component({
  selector: 'app-region-info-page-desktop',
  templateUrl: './region-info-page-desktop.component.html',
  styleUrls: ['./region-info-page-desktop.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NgxSkeletonLoaderModule,
    UserAccountModule,
    LocationListModule,
    MatIconModule,
    SearchInputFieldComponent,
    SearchLinkModule,
    SimpleBreadcrumbComponent,
    TripsListComponent,
    ParseCoordinatesPipe,
    SimpleMapComponent,
    GalleryComponent,
    PopularItinerariesComponent,
    MatMenuTrigger,
    MatMenu,
    ReplaceStrPipe,
    TitleCasePipe,
    AsyncPipe,
    TextEllipsisComponent,
  ],
  providers: [CountryInfoTextService],
})
export class RegionInfoPageDesktopComponent
  extends PageInfoComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() regionResponse: RegionResponse = new RegionResponse();
  @Input() regionDetails: RegionDetails = new RegionDetails();

  public menuOpened: boolean[] = [false];

  constructor(
    protected cdr: ChangeDetectorRef,
    protected scrollToIdService: ScrollToIdService,
    protected countryInfoTextService: CountryInfoTextService,
    private readonly metaTagsConfigService: MetaTagsConfigService,
  ) {
    super(cdr, scrollToIdService);
  }

  ngOnInit() {
    this.setRegionPageSeoTags();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.regionResponse && changes.regionResponse.currentValue) {
      this.setRegionPageSeoTags();
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private setRegionPageSeoTags(): void {
    if (this.regionDetails.name) {
      this.metaTagsConfigService.setRegionSeoTags(
        this.regionDetails.name,
        this.countryDetails.name,
      );
    }
  }
}
